import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Blocks from '../components/bbcode/blocks';
import '../components/fontawesome/fontawesome';
import { createReactEditorJS } from 'react-editor-js';
//import Raw from '@editorjs/raw';
import TimezoneSelect, { allTimezones } from 'react-timezone-select';
import UploadFile from '../components/upload/upload';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import './css/overview.css';
//import './css/header.css';

const ReactEditorJS = createReactEditorJS();

class PortalAdminDetails extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: this.props.service,
				name: '',
			},
			//description: {},
			overview: {
				followers: [],
				socials: {},
			},
			description_temp: {},
			/*followers: [],
			edit: false,
			,
			timezone: null,
			discord: {
				enabled: false,
				visible: false,
			},*/
		};
		this.editorInstance = React.createRef();
		this.getDescription = this.getDescription.bind(this);
		this.setDescription = this.setDescription.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleTimezone = this.handleTimezone.bind(this);
		this.changeAvatar = this.changeAvatar.bind(this);
		this.setDiscord = this.setDiscord.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		await value.setWorker( this.props.service );
		EventEmitter.emit('/client', {data: 'no value'});

		
		//this.setState({status: true, services: x.data.Services});

		/*
		let params = new URLSearchParams();
		const x = await postApi('/v3/index', params);
		//this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});
		*/

		await this.getDescription();
	}

	componentWillUnmount() {
	}


	async getDescription() {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${this.context.worker[this.props.service]}/v3/admin/admin`, params);
		consoleLog(x.data);

		let service = this.state.service;
		service.status = true;
		service.name = x.data.servicename;
		//console.log(x.data);

		let description_temp = this.state.description_temp;
		description_temp.title = x.data.title;
		description_temp.description = x.data.description;
		description_temp.timezone = x.data.timezone;
		description_temp.donation = x.data.donation;

		this.setState({service, overview: x.data, description_temp});
		setTitle('Admin', x.data.title);
	}


	async setDescription() {
		/*let edit = !this.state.edit;
		let description_temp = null;
		if( edit ) {
			description_temp = this.state.description;
		}
		await this.getDescription();
		this.setState({edit, description_temp});*/
	}


	async handleChange(event) {
		let description_temp = this.state.description_temp;
		let item = event.target.value;
		if( event.target.name === "title" ) description_temp.title = item;
		if( event.target.name === "description" ) description_temp.description = item;
		if( event.target.name === "donation" ) description_temp.donation = item;
		this.setState({description_temp});
	}

	handleTimezone(timezone) {
		this.setState({timezone: timezone.value});
	}
	
	

	async submitChanges(type, event) {
		if( event ) event.preventDefault();

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);

		switch( type ) {
			case 'socials':

				//params.append('socials', 'socials');
        let socials = this.state.overview.socials;
				console.log(socials);
        for( let i in socials ) {
          params.append(i, document.getElementById(i).value);

        }

			break;
			default:
				params.append('title', this.state.description_temp.title);
				const outputData = await this.editorInstance.current.save();
				params.append('description', JSON.stringify(outputData.blocks));
				params.append('avatar', this.state.description_temp.avatar);
				params.append('cover', this.state.description_temp.cover);
				params.append('timezone', this.state.timezone);
				params.append('donation', this.state.description_temp.donation);
			break;
		}
		
		//console.log(params);

		await putApi(`${this.context.worker[this.props.service]}/v3/admin/admin`, params);

		//await this.getDescription();

	}

	async changeAvatar(name) {
		let description_temp = this.state.description_temp;
		description_temp.avatar = name;
		this.setState({description_temp});
	}

	setDiscord() {
		let discord = this.state.discord;
		discord.visible = !discord.visible;
		this.setState({discord});
	}

	render() {
		const user = this.context;

		const followers = this.state.overview.followers.map((e, i) => {
			return (
				<Col key={i}>
					<div className="card custom-card">
						<div className="card-body">
							<div className="d-flex align-items-center">
								<div className="me-2">
									<div className="avatar avatar-md bg-success-transparent">
										<img src={`https://cloud.ultrastream.io/images/platforms/${e.platform.toLowerCase()}.png`} alt="Platform Avatar" />
									</div>
								</div>
								<div className="flex-1">
									<a aria-label="anchor" href="javascript:void(0)" className="tx-inverse float-end text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i className="bi bi-three-dots tx-14"></i></a>
									<ul className="dropdown-menu">
										<li><a href="javascript:void(0)" className="dropdown-item border-bottom">Action</a></li>
										<li><a href="javascript:void(0)" className="dropdown-item border-bottom">Another Action</a></li>
										<li><a href="javascript:void(0)" className="dropdown-item">Something Else Here</a></li>
									</ul>
									<div className="mg-b-6">
										<p className="mb-0 tx-13 text-muted">{e.username} Followers</p>
									</div>
									<div className="flex-between">
										{/*<h3 className="tx-20 mb-0 font-weight-normal">{e.followers} here</h3>*/}

										<p className="text-lg fw-semibold mb-1">{e.followers}
											{e.month &&
												<OverlayTrigger
													placement="top"
													delay={{ show: 250, hide: 400 }}
													overlay={<Tooltip id="button-tooltip">
														{e.month[1]>0?'Gained':'Lost'} {Math.abs(e.month[1])} followers in the last month
													</Tooltip>}
												>
													<span>
													{e.month && e.month[0] > 0 &&
														<span className="text-success fs-12 ms-2">
															<FontAwesomeIcon icon="arrow-trend-up" className="me-2 fs-12" />
															{Math.abs(e.month[0])}%
														</span>
													}
													{e.month && e.month[0] < 0 &&
														<span className="text-danger fs-12 ms-2">
															<FontAwesomeIcon icon="arrow-trend-down" className="me-2 fs-12" />
															{Math.abs(e.month[0])}%
														</span>
													}
													</span>
												</OverlayTrigger>
											}
											
										</p>

									</div>
									<div>
										{e?.twitch_bits > 0 &&
											<>Bits {e.twitch_bits}, </>
										}
										{e?.twitch_subscribe > 0 &&
											<>Subscribers {e.twitch_subscribe}, </>
										}
										{e?.twitch_trains > 0 &&
											<>Trains {e.twitch_trains}, </>
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</Col>
			)
		});

		const socials = Object.keys(this.state.overview.socials).map((e,i) => {
      return (
        <li key={i}>
          <div className="row mb-2">
            <label htmlFor={e} className="col-sm-2 col-form-label">{this.state.overview.socials[e].name}</label>
            <div className="col-sm-10">
              <input type="text" className="form-control" name={e} id={e} placeholder={this.state.overview.socials[e].placeholder} defaultValue={this.state.overview[e]} />
            </div>
          </div>
        </li>
      )
    })

		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Dashboard</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">

							<Row>
									
								<Col xs={12}>
									{this.state.overview.followers.length > 0 ?
                 	 <Row>{followers}</Row>
                	:
										<div className="card custom-card">
											<div className="card-header p-0">
												<div className="d-flex p-3 ">
													<div className="">
														<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
													</div>
													<div className="mt-0 text-start">
														<span className="fs-14 fw-semibold">Admin Overview</span>
														<p className="fs-13 text-muted mb-0">Details about your {this.state.overview?.overview?.title}</p>
													</div>
												</div>
											</div>
											{/*<div className="card-body ">
												
											</div>*/}
											<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
										</div>
									}
                </Col>
							</Row>

							<div class="card custom-card">
						    <div class="card-body">
        					
									<Tab.Container id="left-tabs-example" defaultActiveKey="station">
										<Row>
											<Col xl={2} lg={3}>
												<Nav variant="pills" className="nav nav-tabs flex-column nav-style-5">
													<Nav.Item>
														<Nav.Link eventKey="station"><i class="bx bx-cog me-2 fs-18 align-middle"></i>Station Details</Nav.Link>
													</Nav.Item>
													<Nav.Item>
														<Nav.Link eventKey="package"><i class="bx bx-coin-stack me-2 fs-18 align-middle"></i>Package Details</Nav.Link>
													</Nav.Item>
													<Nav.Item>
														<Nav.Link eventKey="socials"><i class="bx bx-label me-2 fs-18 align-middle"></i>Station Socials</Nav.Link>
													</Nav.Item>
													<Nav.Item>
														<Nav.Link eventKey="inactive"><i class="bx bx-label me-2 fs-18 align-middle"></i>Inactive DJ's</Nav.Link>
													</Nav.Item>
												</Nav>
											</Col>
											<Col>
												<Tab.Content>
													<Tab.Pane eventKey="station">
														<div class="p-3">
															<h6 class="fw-semibold mb-3">Radio Station Details:</h6>
															<div class="mb-4 d-sm-flex align-items-center">
																<div class="mb-0 me-sm-5 d-sm-flex align-items-center">
																	<span class="avatar avatar-xxl ">
																		<UploadFile src={this.state.overview.avatar} path={`radio/${this.state.service.id}/avatar/`} onChange={this.changeAvatar}/>
																		<div class="badge rounded-pill bg-primary avatar-badge">
																			<FontAwesomeIcon icon="camera" />
																		</div>
																	</span>
																	<div class="ms-sm-3">
																		<h5 class="text-dark mb-1">{this.state.overview.title}</h5>
																		<p class="text-muted mb-0"><span class="">Admins: </span><span>{this.state.overview.admins.length} of {this.state.overview.adminsMax}</span> </p>
																		<p class="text-muted mb-0"><span class="">DJ's: </span><span>{this.state.overview.members.length} of {this.state.overview.membersMax}</span> </p>
																	</div>
																</div>
															</div>
														</div>

														<Row class="gy-4 mb-4">
															<Col xs={12}>
																<label for="first-name" class="form-label">Radio Station Name:</label>
																<Form.Control type="text" name="title" id="title" value={this.state.description_temp.title} onChange={this.handleChange} className="form-control-sm" placeholder="title" />
															</Col>
															<Col xs={12} className="mt-2">
																<label for="last-name" class="form-label">Description</label>
																<ReactEditorJS
        													/*tools={Raw}*/
																	onInitialize={instance => (this.editorInstance.current = instance)}
        													data={{blocks: (this.state.overview.description&&this.state.overview.description.length>0)?JSON.parse(this.state.overview.description):[]}}
																	
																/>
															</Col>
															<Col xs={12} className="mt-2">
																<label class="form-label">Timezone</label>
																<TimezoneSelect
																	value={this.state.overview.timezone}
																	onChange={this.handleTimezone}
																	labelStyle='abbrev'
																	timezones={{...allTimezones}}
																/>
															</Col>
															<Col xs={12} className="mt-2">
																<label for="first-name" class="form-label">Donation Link:</label>
																<Form.Control type="text" name="donation" id="donation" value={this.state.description_temp.donation} onChange={this.handleChange} className="form-control-sm" placeholder="Donation Link" />
															</Col>
														</Row>

														<div className="card-footer">
															<div className="float-end">
																{/*<Button size="sm" variant="danger" onClick={()=>this.setDescription()}>Cancel</Button>&nbsp;&nbsp;*/}
																<Button size="sm" onClick={()=>this.submitChanges()}>Save Changes</Button>
															</div>
														</div>
																

													</Tab.Pane>
													<Tab.Pane eventKey="package">
														
														
													</Tab.Pane>
													<Tab.Pane eventKey="socials">
														
														<Form onSubmit={(e)=>this.submitChanges('socials',e)}>
															<ul className="list-unstyled">
																<li>
																	<p>
																		Please include your socials such as facebook and instagram for your followers to follow you:
																	</p>
																</li>
																{socials}
																<li>
																	<div className="row mb-2">
																		<label htmlFor="inputEmail3" className="col-sm-2 col-form-label"></label>
																		<div className="col-sm-10">
																			<Button size="sm" onClick={()=>this.submitChanges('socials')}>Save Socials</Button>
																		</div>
																	</div>
																</li>
															</ul>
														</Form>

													</Tab.Pane>
													<Tab.Pane eventKey="inactive">

													</Tab.Pane>
												</Tab.Content>
											</Col>
										</Row>
									</Tab.Container>
								</div>

							</div>

							
						
							
							
							{/*<Row>
								<Col xs={12}>
									<div className="card custom-card custom-frame">
                    <div className="card-header justify-content-between">
                      <div className="card-title">
												{this.state.overview.title}
                      </div>
                    </div>
                    <div className="card-body">
											<Row>
												<Col>
													Invites: {this.state.overview.invites === true?'Open':'Closed'}<br />
													Members: {this.state.overview.overview.membersMax}<br />
													Admins: {this.state.overview.overview.adminsMax}<br />
													<Button size="sm" onClick={this.setDiscord}>Enable Discord</Button>
													
													{/*Ower: <Link to={`/${this.state.overview.owner.username}`}>{this.state.overview.owner.title}</Link><br />
													Admins: {this.state.overview.adminsMax}*}
													{/*(() => {
														const y = this.state.overview.admins.map((g,k) => {
															return(
																<React.Fragment key={k}>&nbsp;- {g.title}</React.Fragment>
															)
														});
															return y;
														})()*}
													<br />
												</Col>
											</Row>
											
										</div>
									</div>
								</Col>
									
							</Row>*/}

							{/*<Row>
								<Col xs={12}>
									{this.state.edit === false ?
										<div className="card custom-card custom-frame">
											<div className="card-header justify-content-between">
												<div className="card-title">
													Your radio station details:
												</div>
												<div className="dropdown d-flex">
													<Button size="sm" variant="success" onClick={()=>this.setDescription()}>Edit Details</Button>
												</div>
											</div>
											<div className="card-body">

												<Row>
													<Col>
														<div className="form-group row pt-1 pb-0 mb-1">
															<div className="d-flex">
																<label className="col-sm-4 col-form-label col-form-label-sm ps-2">
																	<strong>Radio Station Logo</strong>
																</label>
															
																<div className="col-md-6 avatar avatar-xxl">
																	<img src={`https://cloud.ultrastream.io/images/${this.state.description.avatar}`} alt='avatar' />
																</div>
															</div>
														</div>
														<div className="form-group row pt-1 pb-0 mb-1">
															<label htmlFor="title" className="col-sm-4 col-form-label col-form-label-sm ps-4">
																<strong>Radio Station Name</strong>
															</label>
															<div className="col-md-6">
																<h4><small>{this.state.description.title}</small></h4>
															</div>
														</div>
														{/*<div className="form-group row pt-1 pb-0 mb-1">
															<label className="col-sm-4 col-form-label col-form-label-sm ps-4">
																<strong>Radio Station Logo</strong>
															</label>
															<div className="col-md-6 mt-2">
																{/*<Form.Control type="text" name="title" id="title" value={this.state.description_temp.title} onChange={this.handleChange} className="form-control-sm" placeholder="title" />*}
															</div>
														</div>*}
														<div className="form-group row pt-1 pb-0 mb-1">
															<label htmlFor="description" className="col-sm-4 col-form-label col-form-label-sm ps-4">
																<strong>Radio Station Description</strong>
															</label>
															<div className="col-md-6">
																{/*<Form.Control type="text" name="description" id="description" value={this.state.description_temp.description} onChange={this.handleChange} className="form-control-sm" placeholder="title" />*}
																<div className="form-control form-control-sm">
																<Blocks blocks={this.state.description.description} />
																</div>
															</div>
														</div>
														<div className="form-group row pt-1 pb-0 mb-1">
															<label htmlFor="timezone" className="col-sm-4 col-form-label col-form-label-sm ps-4">
																<strong>Radio Station Timezone</strong>
															</label>
															<div className="col-md-6 mt-2">
																{this.state.timezone}
															</div>
														</div>
													</Col>
												</Row>
											</div>
										</div>
									:
										<div className="card custom-card custom-frame">
											<div className="card-header justify-content-between">
												<div className="card-title">
													About your radio station
												</div>
											</div>
											<div className="card-body">
												<Row>
													<Col>
														<div className="form-group row pt-1 pb-0 mb-1">
															<label className="col-sm-4 col-form-label col-form-label-sm ps-4">
																<strong>Radio Station Logo</strong>
															</label>
															<div className="col-md-6 mt-2">
																{/*<UploadFile src={this.state.description_temp.avatar} path={`radio/${this.state.service.id}/avatar/`} onChange={this.changeAvatar}/>*}
															</div>
														</div>
														<div className="form-group row pt-1 pb-0 mb-1">
															<label htmlFor="title" className="col-sm-4 col-form-label col-form-label-sm ps-4">
																<strong>Radio Station Name</strong>
															</label>
															<div className="col-md-6 mt-2">
																{/*<Form.Control type="text" name="title" id="title" value={this.state.description_temp.title} onChange={this.handleChange} className="form-control-sm" placeholder="title" />*}
															</div>
														</div>
														{/*<div className="form-group row pt-1 pb-0 mb-1">
															<label className="col-sm-4 col-form-label col-form-label-sm ps-4">
																<strong>Radio Station Logo</strong>
															</label>
															<div className="col-md-6 mt-2">
																{/*<Form.Control type="text" name="title" id="title" value={this.state.description_temp.title} onChange={this.handleChange} className="form-control-sm" placeholder="title" />*}
															</div>
														</div>*}
														<div className="form-group row pt-1 pb-0 mb-1">
															<label htmlFor="description" className="col-sm-4 col-form-label col-form-label-sm ps-4">
																<strong>Radio Station Description</strong>
															</label>
															<div className="col-md-6 mt-2">
																{/*<Form.Control type="text" name="description" id="description" value={this.state.description_temp.description} onChange={this.handleChange} className="form-control-sm" placeholder="title" />*}
																<div className="form-control form-control-sm">
																	{/*<Form.Control type="text" name="title" id="title" value={this.state.description_temp.title} onChange={this.handleChange} className="form-control-sm" placeholder="title" />*}
																{/*<ReactEditorJS
        													/*tools={Raw}/
																	onInitialize={instance => (this.editorInstance.current = instance)}
        													data={{blocks: (this.state.description.description&&this.state.description.description.length>0)?JSON.parse(this.state.description.description):[]}}
																	
																/>*}
																<TimezoneSelect
																	value={this.state.overview.timezone}
																	onChange={this.handleTimezone}
																	labelStyle='abbrev'
																	timezones={{...allTimezones}}
																/>
																</div>
															</div>
														</div>
														<div className="form-group row pt-1 pb-0 mb-1">
															<label htmlFor="timezone" className="col-sm-4 col-form-label col-form-label-sm ps-4">
																<strong>Radio Station Timezone</strong>
															</label>
															<div className="col-md-6 mt-2">
																<TimezoneSelect
																	value={this.state.overview.timezone}
																	onChange={this.handleTimezone}
																	labelStyle='abbrev'
																	timezones={{...allTimezones}}
																/>
															</div>
														</div>
													</Col>
												</Row>
											</div>
											<div className="card-footer">
												<div className="float-end">
													<Button size="sm" variant="danger" onClick={()=>this.setDescription()}>Cancel</Button>&nbsp;&nbsp;
													<Button size="sm" variant="success" onClick={()=>this.submitChange()}>Save Changes</Button>
												</div>
											</div>
										</div>
									}
								</Col>
									
							</Row>*/}

							{/*<Row>
								<Col xs={12}>
									<div className="card custom-card custom-frame">
                    <div className="card-header justify-content-between">
                      <div className="card-title">
												Inactive DJ Members
                      </div>
											
                    </div>
                    <div className="card-body">
											<Row>
												<Col>
													DJ's that have not yet played or played within 90 days
													
												</Col>
											</Row>
											
										</div>
									</div>
								</Col>
									
							</Row>*/}
							
						</div>
					</div>
				}
				{/*<Modal
					show={false/*this.state.discord.visible*}
					size="lg"
					onHide={this.setDiscord}
					centered
				>
					<Modal.Header closeButton>
						<Modal.Title id="contained-modal-title-vcenter">
							Enable Discord
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<h5>Add Discord Ultrastream Bot</h5>
						<p>
							Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
							dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
							consectetur ac, vestibulum at eros.
						</p>
					</Modal.Body>
					<Modal.Footer>
						<Button size="sm" onClick={this.setDiscord}>Close</Button>
					</Modal.Footer>
				</Modal>*/}
			</>
		);
	}
}

const Admin = props => {
  const { service } = useParams();
  return <PortalAdminDetails service={parseInt(service)} {...props} />
}
export default Admin;